import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACTION_PERMISSION } from '@d-constants/permission.constant';
import { RoleService } from '@d-services';
import { CoreUserService } from '@d-services/core/user.service';

@Directive({
  selector: '[permissionType]',
  standalone: true,
})
export class PermissionDirective implements OnChanges {
  @Input() permissionType: keyof typeof ACTION_PERMISSION;
  @Input() moduleCode?: string | string[];
  @Input() createdBy: string = '';
  @Input() ngIf?: boolean;

  constructor(
    private viewContainer: ViewContainerRef,
    private roleService: RoleService,
    private templateRef: TemplateRef<any>,
    private activatedRoute: ActivatedRoute,
    private userService: CoreUserService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.createdBy && !changes.createdBy.firstChange) ||
      (changes.moduleCode && !changes.moduleCode.firstChange)
    ) {
      this.execute();
    }
  }

  ngOnInit(): void {
    this.execute();
  }

  execute() {
    if (this.ngIf === false) {
      return;
    }

    if (
      this.ngIf === undefined &&
      (!this.permissionType ||
        (this.permissionType &&
          this.roleService.checkPermissionByAction(
            this.moduleCode || this.activatedRoute.snapshot.data['moduleCode'],
            this.permissionType,
            this.createdBy,
          )))
    ) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    if (
      this.permissionType &&
      !this.roleService.checkPermissionByAction(
        this.moduleCode || this.activatedRoute.snapshot.data['moduleCode'],
        this.permissionType,
        this.createdBy,
      )
    ) {
      this.viewContainer.clear();
    }
  }
}
